/**
 * All Afrikaans copy for the site lives here. Edit this file (not the components)
 * to update names, dates, venue info, story beats, FAQ, etc.
 */

export const couple = {
  partnerOne: "Hannes",
  partnerTwo: "Bianca",
  short: "H & B",
  ampersand: "&",
};

export const wedding = {
  date: new Date("2026-10-31T15:00:00+02:00"),
  dateLabel: "31 Oktober 2026",
  weekday: "Saterdag",
  time: "15:00",
  cutoffRsvp: new Date("2026-08-31T23:59:59+02:00"),
  cutoffLabel: "1 September 2026",
};

export const venue = {
  name: "Anderland Trouvenue",
  city: "Potchefstroom",
  address: "Anderland Trouvenue, Potchefstroom",
  mapUrl: "https://maps.google.com/?q=Anderland+Trouvenue+Potchefstroom",
};

export const homeContent = {
  eyebrow: "Saterdag, 31 Oktober 2026 • Potchefstroom",
  scroll: "Blaai om te ontdek",
};

export const story = [
  {
    year: "2012",
    text:
      "Ons het mekaar by 'n graadses verjaarsdagpartytjie ontmoet, waar almal moes \"opdress\". Hannes het sy pa se vlootuniform aangetrek, en Bianca het soos 'n danser gelyk.",
  },
  {
    year: "2015",
    text:
      "Nadat Hannes in graad 8 'n foon gekry het, kon hy uiteindelik vir Bianca vra om te gaan fliek. Tot sy teleurstelling het Bianca gedink dit sal lekkerder wees as haar vriendin saamkom. Hannes het toe maar ook 'n vriend genooi.",
  },
  {
    year: "2018",
    text:
      "Nadat Hannes die goeie nuus ontvang het dat Bianca weer enkellopend was, het hy geen tyd gemors om haar te probeer \"troos\" nie. Hulle het mekaar beter leer ken en saam na talle danse gegaan.",
  },
  {
    year: "2019",
    text:
      "Bianca het in Januarie uiteindelik besluit om vir Hannes 'n kans te gee. Op 15 Februarie 2019 het Hannes vir Bianca gevra om sy meisie te wees.",
  },
  {
    year: "2020",
    text:
      "Ons langafstandverhouding het afgeskop toe Hannes in Potchefstroom begin studeer het. Danksy COVID kon ons die grootste deel van die jaar saam deurbring.",
  },
  {
    year: "2021–2024",
    text:
      "Ons het albei op ons studies gefokus (Bianca dalk 'n bietjie meer as Hannes) en probeer om mekaar elke derde naweek te sien. Só het ons verhouding net sterker geword.",
  },
  {
    year: "2025",
    text:
      "Bianca is in Potchefstroom uitgeplaas vir haar internskap, terwyl Hannes sy finale jaar voltooi en begin werk het. Op 25 Oktober 2025 het ons verloof geraak.",
  },
  {
    year: "2026",
    text:
      "Ons beplan met groot opgewondenheid aan ons troue en tel die slapies af tot die groot dag.",
  },
];

export const program = [
  { time: "14:30", title: "Aankoms", desc: "Welkom met sjampanje en hapies." },
  { time: "15:00", title: "Seremonie", desc: "Die belangrikste deel — moet asseblief betyds wees." },
  { time: "16:00", title: "Foto's & drankies", desc: "Kry koeldrank, vind die bar, ontmoet familie." },
  { time: "18:00", title: "Onthaal", desc: "Drie-gang ete — onthou jou dieet op die RSVP." },
  { time: "20:00", title: "Toesprake", desc: "Bring tissues." },
  { time: "21:00", title: "Eerste dans", desc: "Dans tot die son opkom." },
  { time: "00:00", title: "Laaste rondte", desc: "Veilig ry of slaap by die venue." },
];

export const venueCards = [
  {
    title: "Die seremonie & onthaal",
    body: "Beide vind plaas by Anderland Trouvenue, net buite Potchefstroom. Geen pendel nodig nie.",
  },
  {
    title: "Verblyf",
    body:
      "Daar is verskeie guesthouses en hotelle in Potchefstroom binne kort ry-afstand van die venue. Ons sal binnekort meer aanbevelings hier deel.",
  },
  {
    title: "Parkering",
    body: "Gratis parkering by die venue. Die plek is loodskeddings-vriendelik.",
  },
  {
    title: "Vervoer",
    body: "Reël asseblief vooraf 'n terugrit of slaapplek as jy wil saamkuier — Uber is beperk in Potchefstroom na laataand.",
  },
];

export const faq = [
  {
    q: "Mag ek 'n metgesel saambring?",
    a: "Ongelukkig nie, slegs persone soos aangedui op die uitnodigingsboodskap.",
  },
  {
    q: "Wat is die kleredrag?",
    a: "Semiformeel. Dames, bring julle gemaklike dansskoene saam.",
  },
  {
    q: "Teen wanneer moet ek RSVP?",
    a: "Teen 1 September 2026.",
  },
];

export const gifts = {
  bank: {
    holder: "Bianca van der Vyver",
    bank: "Discovery Bank",
    account: "19011087998",
  },
};

export const navLinks = [
  { href: "/ons-verhaal", label: "Ons Verhaal" },
  { href: "/dag", label: "Die Dag" },
  { href: "/plek", label: "Die Plek" },
  { href: "/galery", label: "Galery" },
  { href: "/geskenke", label: "Geskenke" },
  { href: "/faq", label: "FAQ" },
];
